<template>
    <div>
        <div class="fg-table-wrapper">
            <div class="panel-default fg-table">
                <div class="panel-heading" v-if="showHeading">
                    {{ title }}
                    <slot name="header_button" v-if="createSlug !== '' ">
                        <span class="btn btn-info" @click='createItem'>Luo uusi</span>
                    </slot>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12" v-if="showSearchForm">
                    <div class="form-inline form-group form-search">
                        <div class="input-group">
                            <input v-model="searchFor" placeholder="Haku" class="form-control">
                            <span class="input-group-btn">
                                <button type="submit" class="btn btn-primary">
                                    <i class="fa fa-search"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                    <select v-model="dropDown" class="input-group form-dropdown pull-right" v-if="showDropDown"
                            @change="setDropDown">
                        <option value="">Kaikki</option>
                        <option value="garrison_admin">Varuskunnan ylläpitäjä</option>
                        <option value="Instructor">Ohjaaja</option>
                        <option va lue="Conscript">Varusmies</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="panel-body table-responsive" v-if="showBody">
            <vuetable ref="vuetable"
                       :api-url="endpoint"
                       table-class="vuetable table table-bordered table-striped table-hover"
                       wrapper-class="vuetable-wrapper"
                       table-wrapper=".vuetable-wrapper"
                       loading-class="loading"
                       :sort-order="sortOrder"
                       :multi-sort="multiSort"
                       :append-params="moreParams"
                       ascending-icon="glyphicon glyphicon-chevron-up"
                       descending-icon="glyphicon glyphicon-chevron-down"
                       data-path="data"
                       :fields="columns"
                       paginationPath=""
                       @vuetable:pagination-data="onPaginationData"
                       
            >
                <div class="custom-actions" slot="actions" slot-scope="props">
                    <button class="btn btn-warning"
                    @click="action('edit-item', props.rowData)">
                    <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-danger"
                    @click="action('delete-item', props.rowData)">
                    <i class="fa fa-trash-o"></i>
                    </button>
                </div>

            </vuetable>
            <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            <!--Confirmation!-->
            <fg-modal title="Oletko varma?" :show="showDeleteModal" @ok="deleteItem"
                      @cancel="showDeleteModal=false">
                form.message.delete
            </fg-modal>

            <fg-modal title="Oletko varma?" :show="showCheckModal" @ok="checkItem" @cancel="showCheckModal=false">
                form.message.checkout
            </fg-modal>

            <fg-modal title="Oletko varma?" :show="showDeclineModal" @ok="declineItem"
                      @cancel="showDeclineModal=false">
                form.message.decline
            </fg-modal>
        </div>
        <!--Error!-->
        <fg-modal title="Virhe" v-bind:show="showErrorModal" v-on:ok="showErrorModal=false">
            {{ error }}
        </fg-modal>
    </div>
</template>

<script>
    import {EventBus} from "../event-bus";
    import FgModal from './FgModal.vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable.vue';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import axios from 'axios';
    import moment from 'moment';

    export default {
        components: {
            FgModal,
            Vuetable,
            VuetablePagination,
        },
        props: {
            endpoint: {
                type: String,
                default: ''
            },
            baseUrl: {
                type: String,
                default: ''
            },
            columns: {
                type: Array,
                default() {
                    return [];
                }
            },
            links: {
                type: Array,
                default() {
                    return [{
                        column: '',
                        href: '',
                        id: false,
                        slug: false
                    }]
                }
            },
            title: {
                type: String,
                default: 'Form title',
            },
            createSlug: {
                type: String,
                default: 'form'
            },
            editSlug: {
                type: String,
                default: 'form'
            },
            customSlug: {
                type: String,
                default: 'custom'
            },
            searchFields: {
                type: Array,
                default() {
                    return ['name']
                }
            },
            showSearchForm: {
                type: Boolean,
                default: false
            },
            showDropDown: {
                type: Boolean,
                default: false
            },
            showBody: {
                type: Boolean,
                default: true
            },
            showHeading: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                error: {},
                sortOrder: [{
                    field: 'name',
                    direction: 'asc'
                }],
                searchFor: '',
                dropDown: '',
                multiSort: true,
                moreParams: {},
                actOnId: null,
                showDeleteModal: false,
                showCheckModal: false,
                showErrorModal: false,
                showDeclineModal: false,
                css: {
                    pagination: {
                        infoClass: 'pull-left',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-primary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                        first: '',
                        prev: '',
                        next: '',
                        last: '',
                        },
                    }
                },
            }
        },
        watch: {

        },
        methods: {
            checked(value) {
                return value == 1 ? '<span class="label label-success"> Kyllä </span>' : '<span class="label label-danger"> Ei </span>';
            },
            status(value) {
                switch (value) {
                    case 'approved':
                        return '<span class="label label-success">' + value + '</span>';
                        break;
                    case 'declined':
                        return '<span class="label label-danger">' + value + '</span>';
                        break;
                    default:
                        return '<span class="label label-info">' + value + '</span>';
                }
            },
            number(value) {
                return '<span class="badge">' + value + '</span>';
            },
            clickable(value) {
                return "<a href='javascript:void(0);'>" + value + "</a>";
            },
            countObjects(value) {
                return '<span class="badge">' + _.size(value) + '</span>';
            },
            createItem() {
                window.location.href = this.baseUrl + '/' + this.createSlug;
            },
            formatDate(value, fmt) {
                if (value == null) return ''
                fmt = (typeof fmt == 'undefined') ? 'DD.MM.YYYY' : fmt
                return moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatDateTime(value, fmt) {
                if (value == null || value == '0000-00-00 00:00:00') return '-'
                fmt = (typeof fmt == 'undefined') ? 'DD.MM.YYYY HH:mm:ss' : fmt
                return moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            showDeleteItemModal(id) {
                this.actOnId = id;
                this.showDeleteModal = true;
            },
            showCheckItemModal(id) {
                this.actOnId = id;
                this.showCheckModal = true;
            },
            showDeclineItemModal(id) {
                this.actOnId = id;
                this.showDeclineModal = true;
            },
            closeDeleteModal() {
                this.showDeleteModal = false;
            },
            checkItem() {
                this.showCheckModal = false;
                (this.endpoint + '/' + this.actOnId + '/booking')
                .then((response) => {
                    window.location.href = this.baseUrl;
                }).catch(response => {
                    this.error = response.data.errors.title;
                    this.showErrorModal = true;
                });
            },
            visitItem(data, column) {
                // column = name of the column cell
                // data = link object
                var link = this.links.filter(function (item) {
                    return item.column === column;
                })[0];

                if (link.href != '') {
                    link.id = link.id ? data['id'] : '';
                    link.slug = link.slug ? data['slug'] : '';
                    let url = link.href + link.id + '/' + link.slug;
                    window.location.href = url;
                }
            },
            declineItem() {
                this.showDeclineModal = false;
                axios.get(this.endpoint + '/decline/' + this.actOnId)
                .then((response) => {
                    window.location.href = this.baseUrl;
                }).catch(response => {
                    this.error = response.data.errors.title;
                    this.showErrorModal = true;
                });
            },
            deleteItem() {
                this.showDeleteModal = false;
                axios.delete(this.endpoint + '/' + this.actOnId)
                .then((response) => {
                    window.location.href = this.baseUrl;
                }).catch(response => {
                    this.error = response.response.data.errors.title;
                    this.showErrorModal = true;
                });
            },
            action(action, data) {
                if (action == 'delete-item') {
                    this.showDeleteItemModal(data.id);
                } else if (action == 'edit-item') {
                    window.location.href = this.baseUrl + '/' + this.editSlug + '/' + data.id;
                } else if (action == 'check-item') {
                    this.showCheckItemModal(data.id);
                } else if (action == 'decline-item') {
                    this.showDeclineItemModal(data.id);
                } else if (action == 'open-link') {
                    window.location.href = this.baseUrl + '/' + this.customSlug + '/' + data.id;
                }
            },
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
        },
        events: {
            'vuetable:load-error'(response) {
                console.log('Load Error: ', response)
            },
            'vuetable:load-success'(response) {
                var data = response.data.data
                if (this.searchFor !== '') {
                    for (n in data) {
                        for (field in this.searchFields) {
                            if (this.searchFields[field].indexOf(".") != -1) {
                                data[n][this.searchFields[field]] = this.highlight(this.searchFor, data[n].name)
                            }
                        }
                    }
                }
            },
            'vuetable:load-error'(response) {
                if (response.status == 400) {
                    sweetAlert('Something\'s Wrong!', response.data.errors.detail, 'error')
                } else {
                    sweetAlert(response.data.errors.detail, response.data.errors.title)
                }
            },
            'vuetable:cell-clicked'(data, cell) {
                this.visitItem(data, cell.name);
            }
        }
    }
</script>

<style>
    .vuetable-actions button {
        font-size: 9px;
        margin-right: 10px;
    }

    .fg-table .panel-heading span {
        float: right;
        font-size: 10px;
    }

    .panel-heading span.expand {
        float: left;
        cursor: pointer;
        background-color: #777777;
        color: #fff;
        padding: 4px;
        border-radius: 50%;
    }

    .highlight {
        background-color: yellow;
    }

    [v-cloak] {
        display: none;
    }

    .form-search, form-dropdown {
        padding: 10px 0 0 10px;
        max-width: 250px;
        display: inline-block;
    }

    .form-dropdown {
        margin: 10px;
    }

    /* Loading Animation: */
    .vuetable-wrapper {
        opacity: 1;
        position: relative;
        filter: alpha(opacity=100); /* IE8 and earlier */
    }

    .vuetable-wrapper.loading {
        opacity: 0.4;
        transition: opacity .3s ease-in-out;
        -moz-transition: opacity .3s ease-in-out;
        -webkit-transition: opacity .3s ease-in-out;
    }

    .vuetable-wrapper.loading:after {
        position: absolute;
        content: '';
        top: 40%;
        left: 50%;
        margin: -30px 0 0 -30px;
        border-radius: 100%;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        border: 4px solid #000;
        height: 60px;
        width: 60px;
        background: transparent !important;
        display: inline-block;
        -webkit-animation: pulse 1s 0s ease-in-out infinite;
        animation: pulse 1s 0s ease-in-out infinite;
    }

    .vuetable-pagination {
        background: transparent !important;
    }

    @keyframes pulse {
        0% {
            -webkit-transform: scale(0.6);
            transform: scale(0.6);
        }
        50% {
            -webkit-transform: scale(1);
            transform: scale(1);
            border-width: 12px;
        }
        100% {
            -webkit-transform: scale(0.6);
            transform: scale(0.6);
        }
    }
</style>
